<template lang="pug">
  b-modal#modal-scrollable(
    v-model="show",
    size="md",
    header-class="lmm-common-popup-header",
    :header-bg-variant="dialog.headerBgVariant",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant",
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
      img(src="../../assets/admin_main_log.svg" style="height: 20px")
    b-container(fluid)
      div.context(v-html="$t(dialog.context.path, dialog.context.args, {v: 'DESKTOP-DMTO1NP'})", :style="{'text-align': dialog.align}")
    template(slot="modal-footer")
      b-button.float-right(
        variant="primary"
        @click="close"
      ) {{$t('submit')}}
</template>

<script>
import _ from 'lodash'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark',
  align: 'left'
}
export default {
  name: 'helpOTP-dialog',
  methods: {
    close () {
      this.show = false
    }
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-helpOTP-dialog', data => {
      this.dialog = _.assign(this.dialog, data)
      this.show = true
    })
  },
  data () {
    return {
      show: false,
      dialog: {}
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
